module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_8004.530131e8.png";